import {
  Box,
  Checkbox,
  Stack,
  CheckboxGroup,
  VStack,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { SearchInputBar } from '../SearchInputBar';

interface CheckBoxGroupInputProps {
  options: {
    value: string;
    label: string;
  }[];
  isSearchable?: boolean;
  placeholder?: string;
  onChange: (e: (string | number)[]) => void;
  values: (string | number)[];
}

export function CheckBoxGroupInput({
  options,
  isSearchable,
  placeholder,
  onChange,
  values,
}: CheckBoxGroupInputProps) {
  const [searchValue, setSearchValue] = useState('');
  return (
    <>
      {isSearchable && (
        <SearchInputBar
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          placeholder={placeholder}
          includeIcon={false}
          size={'xs'}
          width={'80%'}
          pb={3}
        />
      )}
      <CheckboxGroup value={values} onChange={onChange}>
        <VStack alignItems="flex-start" h="100px" overflowY="auto" w={'80%'}>
          {options
            .filter((option) =>
              option.label.toLowerCase().includes(searchValue.toLowerCase())
            )
            .map((option, index) => (
              <Checkbox key={`${option.value}-${index}`} value={option.value}>
                <Text fontSize={'sm'} fontWeight={'normal'}>
                  {option.label}
                </Text>
              </Checkbox>
            ))}
        </VStack>
      </CheckboxGroup>
    </>
  );
}

export default CheckBoxGroupInput;
